import { useState } from "react";
import { Label } from "../VersionTab/types";

const useLabelManagement = () => {
  const [labelToDelete, setLabelToDelete] = useState<Label | null>(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  return {
    labelToDelete,
    setLabelToDelete,
    isConfirmationModalOpen,
    setIsConfirmationModalOpen,
  };
};

export default useLabelManagement;
